import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function FieldCell({ children }) {
  return (
    <div css={styles.fieldCell}>
      {children}
    </div>
  );
}

FieldCell.propTypes = {
  children: PropTypes.node,
};

const styles = StyleSheet.create({
  fieldCell: {
    marginTop: 10,
  },
});
